'use client'

import { useState } from 'react'
import { IChannel } from '@giphy/js-types'
import { DeactivateUserButton, DerankUserButton } from './page-header'
import styles from './channel-danger-zone.module.css'
import Button from '@/components/button'

type Props = { channel: IChannel }

const actionButtonClassName = 'bg-gradient-grey hidden h-10 cursor-pointer md:block w-full'
const ChannelDangerZone = ({ channel }: Props) => {
    const [open, setOpen] = useState(false)

    return (
        <div style={{ position: 'relative', display: 'inline-block', marginTop: -4 }}>
            <div
                // eslint-disable-next-line better-tailwindcss/no-unregistered-classes
                className={styles['diagonal-stripes']}
                style={{
                    display: 'inline-block',
                    padding: 4,
                }}
            >
                <Button className={actionButtonClassName} onClick={() => setOpen((v) => !v)}>
                    Click to Moderate
                </Button>
            </div>
            {open && (
                <div
                    style={{
                        position: 'absolute',
                        left: -7,
                        background: '#181818',
                        borderRadius: 2,
                        boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                        padding: '16px 12px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 12,
                        zIndex: 10,
                    }}
                >
                    <DeactivateUserButton channel={channel} />
                    <DerankUserButton channel={channel} />
                </div>
            )}
        </div>
    )
}

export default ChannelDangerZone
